<template>
  <li
    class="LmLandscape"
    :class="{'is-selected': selected}"
    @click.prevent="$emit('select')"
  >
    <h3 class="Title">{{ landscape.name }}</h3>
    <ul class="Info">
      <li>
        <span class="highlight">Actors:</span>&nbsp;{{
          landscape.stats.totalActors
        }}
      </li>
      <li>
        <span class="highlight">Topics:</span>&nbsp;{{
          landscape.stats.totalTopics
        }}
      </li>
      <li>
        <span class="highlight">Users:</span>&nbsp;{{ landscape.users.length }}
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  name: 'LmLandscape',
  components: {},
  props: {
    landscape: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false,
      required: false
    }
  }
}
</script>

<style scoped>
.LmLandscape {
  width: calc(50% - 15px);
  padding: 15px;
  margin: 0 30px 30px 0;
  outline: 1px solid #eaeaea;
  cursor: pointer;
  &:hover {
    background-color: #f2faff;
    outline: none;
  }
  &:nth-child(even) {
    margin-right: 0;
  }
  &.is-selected {
    background-color: #f2faff;
    outline: none;
    .Title {
      color: #0088ff;
    }
  }
  .Title {
    margin-bottom: 15px;
    font-size: 14px;
    line-height: 1.4;
    text-transform: uppercase;
  }
  .Info {
    padding: 0;
    li {
      display: flex;
      align-items: center;
      height: 44px;
      border-bottom: 1px dashed #eaeaea;
      .highlight {
        font-weight: 500;
      }
      &:last-child {
        border: none;
      }
    }
  }
  @media (max-width: 500px) {
    width: 100%;
    margin-right: 0;
  }
}
</style>
